import {getFirstAttributeValue} from '@aboutyou/backbone/helpers/bapiProduct';
import {BapiPrice, BapiProduct} from '@aboutyou/backbone/types/BapiProduct';
import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {TrackingProduct} from '@aboutyou/legacy-tracking-sdk';
import {getProductUrlFromParts} from './getProductUrlFromParts';
import {
  getTrackingColor,
  getTrackingColorFromBapiProduct,
} from './getTrackingColorFromBapiProduct';
import {
  getTrackingPrice,
  getTrackingPriceFromBapiPrice,
} from './getTrackingPrice';
import {getPrice} from './trackingProductGetter';
import {Brand, Product} from './types';

export const getTrackingProduct = (
  product: BapiProduct,
  price: BapiPrice | undefined,
  badges: string[],
): TrackingProduct => {
  const id = product.id;
  const name = getFirstAttributeValue(product.attributes, 'name')?.label || '';
  const brand = getFirstAttributeValue(product.attributes, 'brand');
  const url = getProductUrlFromParts(brand?.label, name, id);

  return {
    id,
    name,
    brand: {
      id: brand?.id || -1,
      name: brand?.label || '*** NO BRAND FOUND ***',
    },
    colors: [getTrackingColorFromBapiProduct(product)],
    minPrice: getTrackingPriceFromBapiPrice(price),
    isSoldOut: product.isSoldOut,
    url,
    masterKey: product.masterKey || '',
    isSponsored: false,
    badges,
  };
};

export const getProduct = ({
  product,
  price,
  brand,
  badges,
}: {
  product: Product;
  price?: Price;
  brand: Brand;
  badges: string[];
}): TrackingProduct => {
  const id = product.id;
  const name = product.name;
  const minPrice = product.price?.minPrice;
  const color = product.colors[0];
  const isSoldOut = product.isSoldOut;

  return {
    id,
    name,
    brand: {
      id: brand?.id || -1,
      name: brand?.name || '*** NO BRAND FOUND ***',
    },
    colors: [getTrackingColor(color)],
    minPrice: getTrackingPrice(minPrice),
    price: getPrice(price),
    isSoldOut,
    url: product.path,
    masterKey: product.masterKey || '',
    isSponsored: product.isSponsored,
    badges,
  };
};
